/**
 * El backend manda fechas sueltas como 'AAAA-MM-DD'. `new Date('2026-07-06')` las
 * parsea como medianoche UTC, así que en GMT-3 se muestran un día antes: el 06/07
 * aparece como 05/07. Estas fechas no tienen hora ni zona — son un día del calendario
 * — así que hay que armarlas en horario local.
 */
export function fechaLocal(valor) {
  if (!valor) return null;
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor));
  if (!partes) return new Date(valor);
  const [, anio, mes, dia] = partes;
  return new Date(Number(anio), Number(mes) - 1, Number(dia));
}

export function formatearFecha(valor) {
  const fecha = fechaLocal(valor);
  return fecha ? fecha.toLocaleDateString('es-AR') : '';
}

/**
 * Inversa de `fechaLocal`: un Date a 'AAAA-MM-DD' en horario local. `toISOString()`
 * pasa a UTC, así que después de las 21:00 en GMT-3 devolvería el día siguiente.
 */
export function fechaLocalISO(fecha) {
  const anio = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  return `${anio}-${mes}-${dia}`;
}
